import styled from 'styled-components'

export const ContainerAvatar = styled.div`
  align-items: center;
  display: flex;
  gap: 10px;
`

export const ContainerCheckbox = styled.div`
  display: flex;
  justify-content: center;
`

export const Container = styled.div`
  align-items: center;
  background-color: white;
  display: flex;
  justify-content: space-between;
  padding: 10px 20px;
`

export const StyledContent = styled.div`
  background-color: white;
`

export const StyledContentArea = styled.div`
  height: 35em;
  overflow: auto;
`
